<template>
  <a
    class="widget-field-attachment-layout"
    :class="{
      'widget-field-attachment-layout--has-error': hasError,
    }"
    :href="downloadUrl"
    target="_blank"
  >
    <div class="widget-field-attachment-layout__content">
      <slot />
    </div>

    <widget-button
      class="widget-field-attachment-layout__remove"
      is-icon-only
      size="20"
      view="transparent"
      @click.stop.prevent="$emit('remove')"
    >
      <widget-icon
        name="close"
        size="16px"
        class="neutral--text"
      />
    </widget-button>
  </a>
</template>

<script lang="ts" setup>
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'

const { downloadUrl, hasError } = defineProps<{
  downloadUrl?: string
  hasError?: boolean
}>()

defineEmits<{
  (event: 'remove'): void
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-field-attachment-layout {
  position: relative;
  padding: 8px;
  border: 1px solid $gray2;
  border-radius: $border-radius-md;
  display: block;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;

  &[href] {
    cursor: pointer;
  }

  &__content {
    width: calc(100% - #{$widgetAttachmentContentRightOffset});
  }

  &__remove {
    position: absolute;
    top: 7px;
    right: $widgetAttachmentRemoveButtonRightOffset;
  }

  &--has-error {
    border-color: $red100;
    background-color: $red50;
  }
}
</style>
